import { FC, useLayoutEffect, useRef, useState } from 'react';
import { Box, Button, Fade, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Colors } from '../controls/helpers';

interface Props {
    onOkay?: () => void;
    okLabel?: string;
    noLabel?: string;
    onNo?: () => void;
    className?: string;
}

const Popup: FC<Props> = (props) => {
    const { children, onOkay, onNo, className, okLabel, noLabel } = props;
    const [open, setOpen] = useState(true);
    const classes = useStyles(props);
    const ref = useRef<HTMLElement>();

    useLayoutEffect(() => {
        ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    return <Box className={clsx(classes.root, className)}>
        <Fade in={open} ref={ref}>
            <Box className={classes.popup}>
                {children}
                <Box className={classes.actions}>
                    {onNo &&
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                                setOpen(false);
                                onNo();
                            }}>
                        {noLabel ?? 'No'}
                        </Button>
                    }
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={() => {
                            setOpen(false);
                            onOkay && onOkay();
                        }}>
                        {okLabel ?? 'Okay'}
                    </Button>
                </Box>
            </Box>
        </Fade>
    </Box>
}

const useStyles = makeStyles({
    root: {
        width: '100%'
    },
    popup: {
        position: 'relative',
        zIndex: 1,
        marginLeft: 'auto',
	    marginRight: 'auto',
        width: 'calc(100% - 24px)',
        '@media(min-width: 768px)': {
            width: 647
        },
        marginBottom: 24,
        backgroundColor: Colors.Black,
        padding: 24,
        borderRadius: 20,
        color: Colors.White
    },
    actions: (props: Props) => ({
        marginTop: 24,
        display: 'flex',
        justifyContent: props.onNo ? 'space-between' : 'center',

    })
}, { name: 'Popup' });

export default Popup;
